// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Layered_cardsContainer__-oEyy","card":"Layered_card__kz8OU","cardTitle":"Layered_cardTitle__ld29B","cardDescription":"Layered_cardDescription__vVPhV"};